module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_commonauth", [["section",{"class":"promo-wrapper auth-page"},[["header",{"class":"common-header scrolled"}],["div",{"id":"notification-container"}],["section",{"class":"common-content","id":"container"}],["footer",{"class":"common-footer"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/commonAuth.tpl
// module id = 243
// module chunks = 2